/*
 * @Author: wushiqing666 8683887+wushiqing666@user.noreply.gitee.com
 * @Date: 2024-01-25 15:01:18
 * @LastEditors: wushiqing666 8683887+wushiqing666@user.noreply.gitee.com
 * @LastEditTime: 2024-01-25 15:21:03
 * @FilePath: \ainote-fe-ainote\src\store\modules\app.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
// 通用

import {three_url, getPlatformId} from 'http/variable'
let dev_test=['localhost:9091','localhost:9092','ainote-t1.iflyresearch.com']
let platform_test=dev_test.includes(location.host)&&(window.localStorage.getItem('platform_test')=='xiaoyin')
const state = {
  appSpinShow: false, // 全局的loading
  userInfo: null, // 用户信息
  isTripartite: location.host.indexOf('label') > -1 || three_url.includes(location.host) || window.localStorage.getItem('platform') === 'tripartite',
  isPrivate: window.localStorage.getItem('platform') === 'private',
  userRole: '', // 用户按钮权限
  userPermission: [1], // window.localStorage.getItem('userPermission') || [1] // 登录获取的用户权限
  platformId:platform_test?'xiaoyin':getPlatformId(location.host)
}

const mutations = {
    // 设置全局
    setAppSpinShow (state, newState) {
        state.appSpinShow = newState;
    },
    // 修改用户信息
    setUserInfo (state, data) {
        if (typeof data === 'string' && data) {
            state.userInfo = JSON.parse(data);
        } else {
            state.userInfo = data;
        }
        window.localStorage.setItem('userInfo', JSON.stringify(state.userInfo))
    },

    // 修改用户权限
    setUserRole (state, data) {
        state.userRole = data;
    },
    // 修改用户权限
    setUserPermission (state, data) {
        window.localStorage.setItem('userPermission', data)
        state.userPermission = data;
    }
};

const actions = {
    setUserInfo (context, data) {
        context.commit('setUserInfo', data)
    },
    setUserRole (context, data) {
        context.commit('setUserRole', data)
    },
    setUserPermission (context, data) {
        context.commit('setUserPermission', data)
    }
};

export default {
    state,
    mutations,
    actions
}
